import script from "./formUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./formUpload.vue?vue&type=script&setup=true&lang=js"

import "./formUpload.vue?vue&type=style&index=0&id=49dad15e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dad15e"]])

export default __exports__